export const GetClientGlobalSettings =
  ({ RestService, HandleError, pResponseClientGlobalSettings }) =>
  async ({ id, clientId }) => {
    try {
      const search = { clientId }
      if (id) {
        search.id = id
      }
      const settings = await RestService.get(
        '/group-orders/client-global-settings',
        search,
      )

      return pResponseClientGlobalSettings(settings)
    } catch (error) {
      if (error.response && error.response.status !== 404) {
        HandleError({ error })
      }

      return {}
    }
  }

export const SaveClientGlobalSettings =
  ({ RestService, UIService, HandleError, pResponseClientGlobalSettings }) =>
  async (clientGlobalSettings, clientName) => {
    let result
    try {
      if (clientGlobalSettings.id) {
        result = await RestService.put(
          `/group-orders/client-global-settings/${clientGlobalSettings.id}`,
          clientGlobalSettings,
        )
      } else {
        result = await RestService.post(
          '/group-orders/client-global-settings',
          clientGlobalSettings,
        )
      }
    } catch (error) {
      HandleError({ error })

      return false
    }
    UIService.FlashMessage.displaySuccessMessage(
      `${clientName} Group Order Global Settings successfully updated`,
    )

    return pResponseClientGlobalSettings(result)
  }

export const SaveStaffingFeeSettings =
  ({ RestService, UIService, HandleError, pResponseClientGlobalSettings }) =>
  async (
    clientGlobalSettingsId,
    globalStaffingFeeSettings,
    locationsConfig,
  ) => {
    let result = null
    try {
      const data = {
        globalConfig: globalStaffingFeeSettings,
        locationsConfig,
      }
      result = await RestService.put(
        `/group-orders/staffing-fee-settings/${clientGlobalSettingsId}`,
        data,
      )
    } catch (error) {
      HandleError({ error })

      return result
    }
    UIService.FlashMessage.displaySuccessMessage(
      'Staffing fee settings successfully updated',
    )

    const { clientGlobalSettings, ...rest } = result

    return {
      clientGlobalSettings: pResponseClientGlobalSettings(clientGlobalSettings),
      ...rest,
    }
  }

export const SaveCustomServiceFeeSettings =
  ({ RestService, UIService, HandleError, pResponseClientGlobalSettings }) =>
  async (clientGlobalSettingsId, globalConfig, locationConfigs) => {
    let result = null
    try {
      const data = {
        globalConfig,
        locationConfigs,
      }
      result = await RestService.put(
        `/group-orders/custom-service-fee-settings/${clientGlobalSettingsId}`,
        data,
      )
    } catch (error) {
      HandleError({ error })

      return result
    }
    UIService.FlashMessage.displaySuccessMessage(
      'Custom service fee settings successfully updated',
    )

    const { clientGlobalSettings, ...rest } = result

    return {
      clientGlobalSettings: pResponseClientGlobalSettings(clientGlobalSettings),
      ...rest,
    }
  }
